import { Channel, Topic } from "../constants/index.js";
import { MessageBrokerUtils } from "./messageBrokerUtils.js";

export class PostLoginUtils {
  static completeAction = actionName => {
    MessageBrokerUtils.publish({
      channel: Channel.POST_LOGIN,
      topic: Topic.completeAction,
      data: {
        actionName
      }
    });
  };
}
